/* Contact options (design A) + Complete the Set (design A): request-info bridge, + Add, See all. */
(function () {
  if (window.__pdpoInit) return;
  window.__pdpoInit = true;

  function refreshCart() {
    // Impulse rebuilds the cart drawer + header count on cart:build without forcing the drawer open.
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  function flash(btn, text, cls) {
    var original = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', original);
    btn.textContent = text;
    btn.classList.remove('is-busy');
    btn.classList.add(cls);
    setTimeout(function () { btn.textContent = original; btn.classList.remove(cls); }, 2400);
  }
  // The enquiry form's popup must live at page level so the tray's "Request info" can open it.
  function hoistAskOverlays() {
    document.querySelectorAll('.ask-widget-overlay').forEach(function (o) {
      if (o.parentNode !== document.body) document.body.appendChild(o);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var ask = t.closest('[data-pdpo-ask]');
    if (ask) {
      e.preventDefault();
      hoistAskOverlays();
      var trig = document.querySelector('[data-ask-widget-open]');
      if (trig) trig.click();
      return;
    }

    var txt = t.closest('[data-pdpo-text]');
    if (txt) {
      e.preventDefault();
      // Ask the Package.ai (PERQ) chat to open itself. Its listener only accepts this from origins
      // allowed in the embed; if the chat hasn't opened shortly after, fall back to the SMS number.
      var form = document.getElementById('paiContactUsForm');
      var opened = function () { return form && form.style.maxWidth && form.style.maxWidth !== '0px' && form.style.maxWidth !== '0'; };
      try { window.postMessage('pai-contactUsExternal:open', '*'); } catch (err) {}
      var sms = txt.getAttribute('data-sms');
      setTimeout(function () {
        if (!opened() && sms) window.location.href = 'sms:' + sms.replace(/[^+\d]/g, '');
      }, 900);
      return;
    }

    var add = t.closest('[data-pdpo-add]');
    if (add) {
      e.preventDefault();
      add.classList.add('is-busy');
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: add.getAttribute('data-variant-id'), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { refreshCart(); flash(add, '✓ Added', 'is-added'); })
        .catch(function () { flash(add, 'Try again', 'is-error'); });
      return;
    }

    var seeAll = t.closest('[data-pdpo-seeall]');
    if (seeAll) {
      var list = seeAll.closest('.pdpo-sa').querySelector('.pdpo-sa__list');
      var ex = list.classList.toggle('is-expanded');
      seeAll.setAttribute('aria-expanded', ex ? 'true' : 'false');
      if (!seeAll.dataset.more) seeAll.dataset.more = seeAll.textContent;
      seeAll.textContent = ex ? seeAll.dataset.less : seeAll.dataset.more;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hoistAskOverlays); else hoistAskOverlays();
  document.addEventListener('shopify:section:load', hoistAskOverlays);
})();
